import { useState } from 'react';
import ButtonLoader from '../ButtonLoader';

const SuperAnnuationAndTax = ({ labourer, isLoading, onSubmit }) => {
  const [superFundName, setSuperFundName] = useState(labourer?.superAnnuation?.fundName || '');
  const [superFundABN, setSuperFundABN] = useState(labourer?.superAnnuation?.ABN || '');
  const [superFundUSI, setSuperFundUSI] = useState(labourer?.superAnnuation?.USI || '');
  const [superMemberNumber, setSuperMemberNumber] = useState(labourer?.superAnnuation?.superMemberNumber || '');
  const [taxFileNumber, setTaxFileNumber] = useState(labourer?.taxFileNumber || '');

  const handleSubmit = (e) => {
    e.preventDefault();

    onSubmit({
      superAnnuation: {
        fundName: superFundName,
        ABN: superFundABN,
        USI: superFundUSI,
        superMemberNumber
      },
      taxFileNumber
    });
  };

  return (
    <>
      <form
        onSubmit={handleSubmit}
        className='flex flex-col gap-4'
      >
        <label className='flex flex-col gap-1'>
          <span>Super Fund Name</span>

          <input
            type="text"
            value={superFundName}
            onChange={(e) => setSuperFundName(e.target.value)}
            required
          />
        </label>

        <label className='flex flex-col gap-1'>
          <span>Super Fund ABN</span>

          <input
            type="text"
            value={superFundABN}
            onChange={(e) => setSuperFundABN(e.target.value)}
            required
          />
        </label>

        <label className='flex flex-col gap-1'>
          <span>Super Fund USI</span>

          <input
            type="text"
            value={superFundUSI}
            onChange={(e) => setSuperFundUSI(e.target.value)}
            required
          />
        </label>

        <label className='flex flex-col gap-1'>
          <span>Super Member Number</span>

          <input
            type="text"
            value={superMemberNumber}
            onChange={(e) => setSuperMemberNumber(e.target.value)}
            required
          />
        </label>

        <label className='flex flex-col gap-1'>
          <span>Tax File Number (TFN)</span>

          <input
            type="text"
            value={taxFileNumber}
            onChange={(e) => setTaxFileNumber(e.target.value)}
            required
          />
        </label>

        <div className='flex'>
          <button
            type="submit"
            className='bg-ase-blue h-[48px] px-4 font-semibold text-white rounded-md'
          >
            {isLoading ? <ButtonLoader /> : 'Update'}
          </button>
        </div>
      </form>
    </>
  )
}

export default SuperAnnuationAndTax;
